import { useState, useEffect } from 'react';
import PressReleaseList from '../components/PressReleaseList';
import { pressReleaseService } from '../services/apiService';

const PressReleases = () => {
  const [releases, setReleases] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const LIMIT = 10;

  const fetchReleases = async (pageNumber = page) => {
    try {
      setLoading(true);
      setError('');
      const response = await pressReleaseService.getPressReleases({ page: pageNumber, limit: LIMIT });
      if (response && response.data) {
        setReleases(response.data || []);
        setTotalPages(response.pagination?.total || 1);
      } else if (Array.isArray(response)) {
        setReleases(response);
        setTotalPages(1);
      }
    } catch (err) {
      setError(err.message || 'Failed to fetch press releases');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchReleases(page);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page]);

  if (loading) {
    return <div className="text-center py-8">Loading press releases...</div>;
  }

  if (error) {
    return <div className="text-center py-8 text-red-500">{error}</div>;
  }

  return (
    <div className="container mx-auto px-4 py-8">
      <h2 className="text-2xl font-medium text-gray-800 mb-6">Press Release Management</h2>
      <PressReleaseList releases={releases} fetchReleases={fetchReleases} />
      <div className="mt-6 flex items-center justify-between">
        <div className="text-sm text-gray-600">Page {page} of {totalPages}</div>
        <div className="space-x-2">
          <button
            onClick={() => setPage(p => Math.max(1, p - 1))}
            disabled={page === 1}
            className={`px-3 py-1 rounded bg-white border ${page === 1 ? 'opacity-50 cursor-not-allowed' : 'hover:bg-gray-100'}`}>
            Prev
          </button>
          <button
            onClick={() => setPage(p => Math.min(totalPages, p + 1))}
            disabled={page === totalPages}
            className={`px-3 py-1 rounded bg-white border ${page === totalPages ? 'opacity-50 cursor-not-allowed' : 'hover:bg-gray-100'}`}>
            Next
          </button>
        </div>
      </div>
    </div>
  );
};

export default PressReleases;
